import { useEffect, useSyncExternalStore } from 'react';
import {
    abonniereGesperrteKonten,
    gesperrteKontenStand,
    holeGesperrteKonten,
} from '../services/gesperrteKonten';

/**
 * Ids der gesperrten Mitglieder (Nr. 148) für Auswahllisten — zusammen mit
 * `ohneGesperrte` aus `services/gesperrteKonten`. Leer, solange nichts
 * geladen ist oder die Migration fehlt; dann blendet niemand etwas aus.
 */
export function useGesperrteKonten(): ReadonlySet<string> {
    const stand = useSyncExternalStore(abonniereGesperrteKonten, gesperrteKontenStand, gesperrteKontenStand);
    useEffect(() => { holeGesperrteKonten(); }, []);
    return stand;
}
